import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { createClient } from "@supabase/supabase-js";
import "../../dist.css/UserMealListPage.css";
// Supabase bağlantısını oluşturuyoruz
const supabase = createClient(
  "https://qlgwpthiwclfbgzzjmjw.supabase.co",
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InFsZ3dwdGhpd2NsZmJnenpqbWp3Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3MjQ2MDUzOTIsImV4cCI6MjA0MDE4MTM5Mn0.N9-IULDnpuUWR_PNXvXyzdTTIMRsxRAxVGrAagaJn4k"
);

const MealListPage = () => {
  const [meals, setMeals] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchMeals = async () => {
      const { data, error } = await supabase.from("meals").select("*"); // Tüm yemekleri seçiyoruz

      if (error) {
        console.error("Hata oluştu:", error);
        setError(error.message);
        setLoading(false);
        return;
      }

      // console.log("Yemekler:", data); // Burada veriyi kontrol ediyoruz
      setMeals(data);
      setLoading(false);
    };

    fetchMeals();
  }, []);

  if (loading) return <div>Yükleniyor...</div>;
  if (error) return <div>{error}</div>;

  return (
    <div className="UserMealListPage">
      <h2 id="user__meal__list__page__title">Sizin Yemekleriniz</h2>
      <ul>
        {meals.length === 0 ? (
          <li>Yemek bulunamadı.</li>
        ) : (
          meals.map((meal) => (
            <li key={meal.id}>
              <Link to={`/userMeal/${meal.id}`}>
                {/* Yemek başlığı */}
                <h2>{meal.title}</h2>
                {/* Yemek resmi */}
                {meal.image_url && (
                  <img src={meal.image_url} alt={meal.title} width="200" />
                )}
              </Link>
            </li>
          ))
        )}
      </ul>
    </div>
  );
};

export default MealListPage;
